export const DIGITAL_PRODUCT = 'digital';
export const VIDEO_TYPE = 'video';

export const errorMessageProps = {
  style: {
    'textAlign': 'center',
    '@md': {
      textAlign: 'left'
    }
  }
};

export const imageZoomContainerStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  height: '100%;',
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  background: 'rgba(0, 0, 0, .85)',
  zIndex: '9999999'
};

export const zoomHelperStyles = {
  position: 'absolute',
  left: '50%',
  bottom: 'xsmall',
  transform: 'translate(-50%, 0)',
  width: 'auto',
  background: 'rgba(0, 0, 0, .9)',
  color: '#fff',
  padding: '3px 6px',
  borderRadius: '3px',
  textTransform: 'uppercase',
  fontSize: 'small',
  maxWidth: '90%',
  zIndex: 10
};

export const lightboxCloseStyles = {
  position: 'absolute',
  top: '0',
  right: 'xsmall',
  fontSize: '40px',
  cursor: 'pointer',
  color: '#fff'
};

export const hoverTextStyles = {
  marginBottom: 'xxsmall',
  textTransform: 'uppercase',
  fontSize: 'small',
  fontColor: 'lowContrast',
  textAlign: 'center'
};

export const videoContainerStyles = {
  'position': 'relative',
  'height': '100%',
  'width': '100%',
  '@xs-only': {
    maxWidth: '80%',
    maxHeight: '80%'
  }
};

export const productAssetImageInner = {
  display: 'flex',
  justifyContent: 'center',
  position: 'absolute',
  top: '0px',
  bottom: '0px',
  left: '0px',
  right: '0px'
};

export const iconWithLabelStyles = {
  row: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {},
  label: {
    display: 'inline-flex',
    verticalAlign: 'middle'
  },
  iconContainer: {
    marginRight: 'xxsmall',
    verticalAlign: 'bottom',
    display: 'inline-flex'
  }
};
